import React from 'react';
// import { motion } from 'framer-motion';
// import { Link } from 'react-router-dom';
// import SafeIcon from '../common/SafeIcon';
// import ExitIntentPopup from './ExitIntentPopup';
// import useExitIntent from '../hooks/useExitIntent';
// import { trackPageView, trackButtonClick, trackVideoPlay, trackOutboundClick } from '../utils/analytics';
// import * as FiIcons from 'react-icons/fi';

// const { FiArrowLeft, FiPlay, FiArrowRight, FiCheck, FiShield, FiClock, FiCode, FiZap, FiStar } = FiIcons;

const BuildAppsWithAIPage = () => {
  return (
    <div className="min-h-screen bg-black-900 text-white flex flex-col items-center justify-center p-4">
      <h1 className="text-4xl font-bold mb-4 font-serif">Page Temporarily Disabled</h1>
      <p className="text-lg text-black-300">This page is currently unavailable.</p>
    </div>
  );
  /*
  const [showCTAButton, setShowCTAButton] = useState(false);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const { showExitIntent, closeExitIntent } = useExitIntent();

  useEffect(() => {
    trackPageView('Build Apps With AI Free Module Page');
    
    // Show CTA button after 3 minutes (180 seconds)
    const timer = setTimeout(() => {
      setShowCTAButton(true);
    }, 180000);

    return () => clearTimeout(timer);
  }, []);

  const handleVideoPlay = () => {
    setIsVideoPlaying(true);
    trackVideoPlay('Build Apps With AI Free Module Video');
  };

  const handleCTAClick = (location = 'main') => {
    trackButtonClick('ai_course_cta', location);
    trackOutboundClick('https://lp2.itskaivalya.com', 'AI Course Landing Page');
    window.open('https://lp2.itskaivalya.com', '_blank');
  };

  // Animation variants
  const fadeInUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } };

  return (
    <div className="min-h-screen bg-white">
      
      {showExitIntent && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[9999] flex items-center justify-center p-4"
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              closeExitIntent();
            }
          }}
        >
          <motion.div
            initial={{ scale: 0.8, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.8, opacity: 0, y: 20 }}
            className="bg-white rounded-xl shadow-2xl max-w-lg w-full mx-4 relative overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            
            <button
              onClick={closeExitIntent}
              className="absolute top-3 right-3 z-10 w-7 h-7 bg-black-100 hover:bg-black-200 rounded-full flex items-center justify-center transition-colors"
            >
              <SafeIcon icon={FiIcons.FiX} className="w-3 h-3 text-black-600" />
            </button>

            
            <div className="bg-gradient-to-r from-blue-600 to-purple-700 p-6 text-white text-center">
              <div className="flex items-center justify-center mb-3">
                <SafeIcon icon={FiCode} className="w-8 h-8 mr-3" />
                <h2 className="text-2xl font-bold">Wait! Don't Miss This!</h2>
              </div>
              <h3 className="text-xl font-semibold mb-2">
                Ready to Build Apps with AI? 🚀
              </h3>
              <p className="text-white/90 text-lg">
                Join the Full Course & Watch Me Build Apps Live!
              </p>
            </div>

            
            <div className="p-6">
              <div className="text-center mb-6">
                <h4 className="text-xl font-bold text-black-900 mb-4">
                  🎯 What You'll Get in the Full Course:
                </h4>
                <div className="space-y-3 text-left mb-6">
                  {[
                    "Watch me build apps, websites & tools LIVE on screen",
                    "Step-by-step AI development tutorials in English, Hindi & Marathi", 
                    "Build real projects that you can showcase",
                    "No coding experience needed - AI does the heavy lifting",
                    "Complete portfolio of working applications"
                  ].map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <SafeIcon icon={FiCheck} className="w-5 h-5 text-green-500 mt-0.5 flex-shrink-0" />
                      <span className="text-black-700">{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
                  <div className="flex items-center justify-center mb-2">
                    <SafeIcon icon={FiShield} className="w-6 h-6 text-green-600 mr-2" />
                    <span className="font-bold text-green-800">60-Day Money Back Guarantee</span>
                  </div>
                  <p className="text-green-700 text-sm">
                    Try the complete course risk-free. If you're not satisfied, get 100% refund within 60 days.
                  </p>
                </div>

                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => handleCTAClick('exit_popup')}
                  className="w-full py-4 bg-gradient-to-r from-blue-600 to-purple-700 text-white rounded-lg font-bold text-lg hover:from-blue-700 hover:to-purple-800 transition-all shadow-lg flex items-center justify-center gap-2"
                >
                  <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
                  <span>Join Full Course Now!</span>
                </motion.button>

                <p className="text-black-500 text-sm mt-3">
                  ⏰ Limited time offer • Instant access after enrollment
                </p>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}

      
      <Link to="/" className="fixed top-4 left-4 z-50 bg-black-900/80 p-2 rounded-full hover:bg-black-900 transition-colors">
        <SafeIcon icon={FiArrowLeft} className="w-5 h-5 text-white" />
      </Link>

      
      <section className="pt-20 pb-16 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{ visible: { transition: { staggerChildren: 0.2 } } }}
            className="text-center mb-12"
          >
            <motion.h1
              variants={fadeInUp}
              className="text-4xl md:text-6xl font-bold text-black-900 mb-6 font-serif leading-tight"
            >
              Build Apps, Websites & Tools
              <br />
              <span className="text-blue-400">With AI - Free Module</span>
            </motion.h1>
            <div className="w-24 h-1 bg-black-900 mx-auto mt-6 mb-8"></div>
            <motion.p
              variants={fadeInUp}
              className="text-xl text-black-700 max-w-3xl mx-auto mb-8"
            >
              Watch this exclusive free module and discover how AI can help you build real applications without coding experience
            </motion.p>
            <motion.div
              variants={fadeInUp}
              className="flex flex-wrap justify-center gap-6 text-sm text-black-600 mb-8"
            >
              <div className="flex items-center gap-2">
                <SafeIcon icon={FiCheck} className="w-4 h-4 text-green-500" />
                <span>No coding required</span>
              </div>
              <div className="flex items-center gap-2">
                <SafeIcon icon={FiZap} className="w-4 h-4 text-green-500" />
                <span>AI-powered development</span>
              </div>
              <div className="flex items-center gap-2">
                <SafeIcon icon={FiStar} className="w-4 h-4 text-green-500" />
                <span>Live demonstrations</span>
              </div>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="max-w-4xl mx-auto"
          >
            <div className="relative aspect-video bg-black rounded-xl overflow-hidden shadow-2xl">
              {!isVideoPlaying ? (
                <div
                  className="relative w-full h-full bg-gradient-to-br from-black-800 to-black-900 flex items-center justify-center cursor-pointer group"
                  onClick={handleVideoPlay}
                >
                  <div className="absolute inset-0 bg-black/20"></div>
                  <motion.div
                    className="relative z-10 w-24 h-24 bg-blue-600 rounded-full flex items-center justify-center shadow-2xl group-hover:bg-blue-700 transition-colors"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                    animate={{
                      scale: [1, 1.05, 1],
                      boxShadow: [
                        "0 0 0 0 rgba(37,99,235,0.7)",
                        "0 0 0 20px rgba(37,99,235,0)",
                        "0 0 0 0 rgba(37,99,235,0)"
                      ]
                    }}
                    transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                  >
                    <SafeIcon icon={FiPlay} className="w-10 h-10 text-white ml-1" />
                  </motion.div>
                  <div className="absolute bottom-6 left-6 right-6 text-white">
                    <h3 className="text-2xl font-bold mb-2">Build Apps, Websites & Tools With AI - Free Module</h3>
                    <p className="text-white/80">Learn to build apps with AI - No coding required</p>
                  </div>
                  <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 translate-y-16 text-white text-center">
                    <p className="text-lg font-semibold">Click to Watch Free Training</p>
                  </div>
                </div>
              ) : (
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/dY2Xme2deFg?autoplay=1&controls=1&modestbranding=1&rel=0&showinfo=0"
                  title="Build Apps With AI Free Module"
                  frameBorder="0"
                  allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture"
                  allowFullScreen
                  className="w-full h-full"
                ></iframe>
              )}
            </div>

            
            {showCTAButton && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="text-center mt-8"
              >
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => handleCTAClick('video_cta')}
                  className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-700 text-white rounded-lg font-bold text-lg hover:from-blue-700 hover:to-purple-800 transition-all shadow-lg flex items-center gap-2 mx-auto"
                >
                  <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
                  <span>Join Full Course & Watch Me Build Live!</span>
                </motion.button>
                <p className="text-black-600 mt-3">
                  🎯 60-Day Money Back Guarantee • Instant Access
                </p>
              </motion.div>
            )}
          </motion.div>
        </div>
      </section>

      
      <section className="py-20 bg-black-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="text-center mb-12"
          >
            <h2 className="text-3xl md:text-4xl font-bold text-black-900 mb-6 font-serif">
              What You'll Learn in the Full Course
            </h2>
            <div className="w-24 h-1 bg-black-900 mx-auto mt-6 mb-8"></div>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {[
              {
                icon: FiCode,
                title: "Live App Development",
                description: "Watch me build real applications live on screen - every click, every step explained"
              },
              {
                icon: FiZap,
                title: "AI-Powered Tools",
                description: "Master the latest AI tools that do the coding for you - no programming background needed"
              },
              {
                icon: FiStar,
                title: "Real Projects",
                description: "Build actual websites, apps, and tools that you can use or sell to clients"
              },
              {
                icon: FiShield,
                title: "Multi-Language Support",
                description: "Complete course delivered in English, Hindi & Marathi for better understanding"
              },
              {
                icon: FiClock,
                title: "Self-Paced Learning",
                description: "Learn at your own speed with lifetime access to all course materials"
              },
              {
                icon: FiIcons.FiUsers,
                title: "Portfolio Building",
                description: "Create a portfolio of working applications to showcase your new skills"
              }
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-sm border border-black-200 text-center"
              >
                <div className="w-12 h-12 bg-black-900 rounded-full flex items-center justify-center mx-auto mb-4">
                  <SafeIcon icon={feature.icon} className="w-6 h-6 text-white" />
                </div>
                <h3 className="text-xl font-bold text-black-900 mb-3">{feature.title}</h3>
                <p className="text-black-700">{feature.description}</p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center"
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => handleCTAClick('features_section')}
              className="px-8 py-4 bg-black-900 text-white rounded-lg font-bold text-lg hover:bg-black-800 transition-colors shadow-lg flex items-center gap-2 mx-auto"
            >
              <span>Start Building Apps Today</span>
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </motion.button>
          </motion.div>
        </div>
      </section>

      
      <section className="py-20 bg-black-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeInUp}
            className="text-center"
          >
            <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-6">
              <SafeIcon icon={FiShield} className="w-10 h-10 text-white" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 font-serif">
              60-Day Money Back Guarantee
            </h2>
            <div className="w-24 h-1 bg-white mx-auto mt-6 mb-8"></div>
            <p className="text-xl text-black-200 leading-relaxed mb-8 max-w-3xl mx-auto">
              Try the complete course risk-free for 60 days. If you don't learn to build apps with AI or you're not completely satisfied, get 100% of your money back. No questions asked.
            </p>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => handleCTAClick('guarantee_section')}
              className="px-8 py-4 bg-white text-black-900 rounded-lg font-bold text-lg hover:bg-black-100 transition-colors shadow-lg flex items-center gap-2 mx-auto"
            >
              <span>Join Risk-Free Today</span>
              <SafeIcon icon={FiArrowRight} className="w-5 h-5" />
            </motion.button>
          </motion.div>
        </div>
      </section>
    </div>
  );
  */
};

export default BuildAppsWithAIPage;